import { Flex, Icon, Text, cn } from '@bridebook/aura';
import { Pencil } from '@bridebook/aura/src/icons';

type Props = {
  label: string;
  body: string;
  className?: string;
  classNames?: {
    label?: string;
    body?: string;
  };
  rightElement?: React.ReactNode;
};
export const ListItem = ({ label, body, className, classNames, rightElement }: Props) => (
  <Flex className={cn('w-full items-center gap-2 border-b border-space-15 text-left', className)}>
    <Flex className="flex-1 flex-col overflow-hidden py-2">
      <Text
        variant="typo-xs-semibold"
        className={cn(
          'overflow-hidden leading-[16px] text-ellipsis whitespace-nowrap text-space-75',
          classNames?.label,
        )}>
        {label}
      </Text>
      <Text
        variant="typo-base"
        className={cn(
          'overflow-hidden leading-[24px] text-ellipsis whitespace-nowrap text-space',
          classNames?.body,
        )}>
        {body}
      </Text>
    </Flex>
    {rightElement || <Icon icon={Pencil} className="text-indigo-crush" size={24} />}
  </Flex>
);
